// cmp/admin/Users.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  PlusIcon,
  TrashIcon,
} from '@heroicons/react/24/outline';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from 'axios';
import { baseUrl } from '../../baseurl';
axios.defaults.baseURL = baseUrl;

const AddUser = () => {
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('address');
  const [loadingBtn, setLoadingBtn] = useState(false);

  // Form state
  const [formData, setFormData] = useState({
      "center": "",
      "name": "",
      "email": "",
      "password": "",
      "device_password": "",
      "ip": "",
      "phone": "",
      "alternate_phone": "",
      "address": "",
      "city": "",
      "state": "",
      "country": "India",
      "note": "",
      "role": "user",
      "license": "",
      "port_no": "",
      "user_id": "",
      "ips": "",
      "return_ip": ""
  });



  useEffect(() => {
    setLoading(false);
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const token = localStorage.getItem('relay_server_token');
    setLoadingBtn(true);
    try {
      const response = await axios.post("/admin/save-user", formData, {
        headers: {
          Authorization: `Bearer ${token}` 
        }
      });

      if (response.data.success) {
        toast.success("User registered successfully!");
        setFormData({ name: "", email: "", password: "", port_no:"", phone: "", confirmPassword: "", center: "", reg_code: "00" });
        // setTimeout(()=>{
        //   navigate("/");
        // },3000);
        

      } else {
        console.log(response);
        toast.error(response?.data?.message || "Something went wrong!");
      }
    } catch (error) {
      console.error("Registration Error:", error.response);
      toast.error(error?.response?.data?.message);
    }
    setLoadingBtn(false);
  };

  const generateLicense = () => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let license = '';

    for (let i = 0; i < 8; i++) {
      license += characters.charAt(Math.floor(Math.random() * characters.length));
    }

    setFormData(prev => ({
      ...prev,
      license: license
    }));
  };

  const generateUserId = () => {
    const characters = '0123456789';
    let user_id = '';

    for (let i = 0; i < 8; i++) {
      user_id += characters.charAt(Math.floor(Math.random() * characters.length));
    }

    setFormData(prev => ({
      ...prev,
      user_id: user_id
    }));
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Add ClassRoom</h1>
          <p className="text-gray-600">Create new user account</p>
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
      {/* Main Form */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden">
        <form onSubmit={handleSubmit} className="p-6">
          <div className='grid grid-cols-2 gap-8'>
            {/* Left Column - Basic Info */}
            <div className='py-4'>
              <div className="space-y-6">
                {/* Centre Name */}
                <div className="flex items-center gap-6">
                  <label className="block text-sm font-medium text-gray-700 w-32">
                    Centre Name *
                  </label>
                  <div className="flex-1">
                    <input
                      type="text"
                      name="center"
                      value={formData.center}
                      onChange={handleInputChange}
                      required
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="Enter centre name"
                    />
                  </div>
                </div>

                {/* User Name */}
                <div className="flex items-center gap-6">
                  <label className="block text-sm font-medium text-gray-700 w-32">
                    User Name *
                  </label>
                  <div className="flex-1">
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="Enter user name"
                    />
                  </div>
                </div>

                {/* Email */}
                <div className="flex items-center gap-6">
                  <label className="block text-sm font-medium text-gray-700 w-32">
                    Email *
                  </label>
                  <div className="flex-1">
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="Enter email address"
                    />
                  </div>
                </div>

                
                {/* Reg Code */}
                <div className="flex items-center gap-6">
                  <label className="block text-sm font-medium text-gray-700 w-32">
                    License *
                  </label>
                  <div className="flex-1 flex">
                    <input
                      type="text"
                      name="license"
                      value={formData.license}
                      onChange={handleInputChange}
                      required
                      className="flex-1 border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="Enter Licence code"
                    />
                    <button
                      type="button"
                      onClick={generateLicense}
                      title="Generate Licence"
                      className="flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors whitespace-nowrap"
                    >
                      <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                      </svg>
                      
                    </button>
                    
                  </div>
                </div>

                
                {/* Password */}
                <div className="flex items-center gap-6">
                  <label className="block text-sm font-medium text-gray-700 w-32">
                    Device Password *
                  </label>
                  <div className="flex-1">
                    <input
                      type="text"
                      name="device_password"
                      value={formData.device_password}
                      onChange={handleInputChange}
                      required
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="Enter password"
                    />
                  </div>
                </div>

                {/* Reg Code */}
                <div className="flex items-center gap-6">
                  <label className="block text-sm font-medium text-gray-700 w-32">
                    Device ID *
                  </label>
                  <div className="flex-1 flex">
                    <input
                      type="text"
                      name="user_id"
                      value={formData.user_id}
                      onChange={handleInputChange}
                      required
                      className="flex-1 border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="Enter Device ID"
                    />
                    <button
                      type="button"
                      onClick={generateUserId}
                      title="Generate UserId"
                      className="flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors whitespace-nowrap"
                    >
                      <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                      </svg>
                      
                    </button>
                    
                  </div>
                </div>

                <div className="flex items-center gap-6">
                  <label className="block text-sm font-medium text-gray-700 w-32">
                    IP *
                  </label>
                  <div className="flex-1">
                    <input
                      type="text"
                      name="ip"
                      value={formData.ip}
                      onChange={handleInputChange}
                      required
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="198.127.11.1"
                    />
                  </div>
                </div>
                <div className="flex items-center gap-6">
                  <label className="block text-sm font-medium text-gray-700 w-32">
                    Return IP *
                  </label>
                  <div className="flex-1">
                    <input
                      type="text"
                      name="return_ip"
                      value={formData.return_ip}
                      onChange={handleInputChange}
                      required
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="198.127.11.1"
                    />
                  </div>
                </div>

                <div className="flex items-center gap-6">
                  <label className="block text-sm font-medium text-gray-700 w-32">
                    Port No *
                  </label>
                  <div className="flex-1">
                    <input
                      type="number"
                      name="port_no"
                      value={formData.port_no}
                      onChange={handleInputChange}
                      required
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="Enter Port Number"
                    />
                  </div>
                </div>

                {/* Password */}
                <div className="flex items-center gap-6">
                  <label className="block text-sm font-medium text-gray-700 w-32">
                    Password *
                  </label>
                  <div className="flex-1">
                    <input
                      type="password"
                      name="password"
                      value={formData.password}
                      onChange={handleInputChange}
                      required
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="Enter password"
                    />
                  </div>
                </div>
                <div className="flex items-center gap-6">
                      <label className="block text-sm font-medium text-gray-700 w-32">
                        Role
                      </label>
                      <div className="flex-1">
                        <select
                          name="role"
                          value={formData.role}
                          onChange={handleInputChange}
                          className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        >
                          <option value="user">User</option>
                          
                          
                        </select>
                      </div>
                    </div>
              </div>
            </div>

            {/* Right Column - Tabs */}
            <div>
              {/* Tabs Navigation */}
              <div className="border-b border-gray-200">
                <nav className="flex -mb-px">
                  <button
                    onClick={() => setActiveTab('address')}
                    type="button"
                    className={`py-4 px-6 text-sm font-medium border-b-2 transition-colors ${
                      activeTab === 'address'
                        ? 'border-blue-500 text-blue-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    Address
                  </button>
                  
                  <button
                    onClick={() => setActiveTab('contact')}
                    type="button"
                    className={`py-4 px-6 text-sm font-medium border-b-2 transition-colors ${
                      activeTab === 'contact'
                        ? 'border-blue-500 text-blue-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    Contact
                  </button>
                  <button
                    onClick={() => setActiveTab('note')}
                    type="button"
                    className={`py-4 px-6 text-sm font-medium border-b-2 transition-colors ${
                      activeTab === 'note'
                        ? 'border-blue-500 text-blue-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    Note
                  </button>
                </nav>
              </div>

              {/* Tab Content */}
              <div className="py-4">
                {/* Address Tab */}
                {activeTab === 'address' && (
                  <div className="space-y-4">
                    
                    <div className="flex items-center gap-6">
                      <label className="block text-sm font-medium text-gray-700 w-32">
                        Address
                      </label>
                      <div className="flex-1">
                        <textarea
                          rows="3"
                          name="address"
                          value={formData.address}
                          onChange={handleInputChange}
                          className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                          placeholder="Enter Address"
                        />
                      </div>
                    </div>
                    <div className="flex items-center gap-6">
                      <label className="block text-sm font-medium text-gray-700 w-32">
                        City 
                      </label>
                      <div className="flex-1">
                        <input
                          type="text"
                          name="city"
                          value={formData.city}
                          onChange={handleInputChange}
                          className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                          placeholder="Enter city"
                        />
                      </div>
                    </div>

                    <div className="flex items-center gap-6">
                      <label className="block text-sm font-medium text-gray-700 w-32">
                        State
                      </label>
                      <div className="flex-1">
                        <input
                          type="text"
                          name="state"
                          value={formData.state}
                          onChange={handleInputChange}
                          className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                          placeholder="Enter state"
                        />
                      </div>
                    </div>

                    <div className="flex items-center gap-6">
                      <label className="block text-sm font-medium text-gray-700 w-32">
                        Country
                      </label>
                      <div className="flex-1">
                        <input
                          type="text"
                          name="country"
                          value={formData.country}
                          onChange={handleInputChange}
                          className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-50"
                          readOnly
                        />
                      </div>
                    </div>

                    
                  </div>
                )}

                
                {/* Contact Tab */}
                {activeTab === 'contact' && (
                  <div className="space-y-4">
                    
                    <div className="flex items-center gap-6">
                      <label className="block text-sm font-medium text-gray-700 w-32">
                        Phone
                      </label>
                      <div className="flex-1">
                        <input
                          type="number"
                          name="phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                          className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                          placeholder="Enter phone number"
                        />
                      </div>
                    </div>

                    <div className="flex items-center gap-6">
                      <label className="block text-sm font-medium text-gray-700 w-32">
                        Alternate Phone
                      </label>
                      <div className="flex-1">
                        <input
                          type="number"
                          name="alternate_phone"
                          value={formData.alternate_phone}
                          onChange={handleInputChange}
                          className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                          placeholder="Enter alternate phone"
                        />
                      </div>
                    </div>

                  </div>
                )}

                {/* Note Tab */}
                {activeTab === 'note' && (
                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Additional Notes
                      </label>
                      <textarea
                        name="note"
                        value={formData.note}
                        onChange={handleInputChange}
                        rows={6}
                        className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Enter any additional notes or comments..."
                      />
                    </div>
                    
                    <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
                      <p className="text-sm text-yellow-800">
                        *Binding of Location IP with Centre Name
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end pt-6 border-t border-gray-200 mt-6">
            <div className="flex space-x-3">
              <button
                type="button"
                className="px-6 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors font-medium"
              >
                CANCEL
              </button>
              <button
                type="submit"
                disabled={loadingBtn}
                className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
              >
                { loadingBtn ? "Wait..." : "CREATE" }
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddUser;